<template>
       <div>
        <v-autocomplete
        append-icon="search" v-model="model" :items="items" :loading="isLoading" :search-input.sync="search" clearable
            hide-details  item-text="TurAdi" item-value="Id" label="Master Paket"></v-autocomplete>
       </div>
</template>
<script>
import tool from "../tools";

export default {
    data: () => ({
        isLoading: false,
        items: [],
        model: null,
        search: null,
        tab: null,
    }),
    watch: {
        search(val) {
            this.isLoading = true
            this.MasterTurList(0);
        },
        model(val){
          this.$emit("input",val ? val : 0)
        }
    },
    mounted() {
      if(this.masterTurId !== 0){
        this.MasterTurList(this.masterTurId);
      }
    },
    computed:{
      Model:{
        get: function() {
          console.log("getter")
          return this.value;
      },
      set: function(newValue) {
        console.log(newValue,"newvalue")
        this.$emit("input", newValue);
      }
      },
    },
    props: {
        masterTurId: {
            type: Number,
            required: true,
        },
    },
    methods:{
        MasterTurList(ref) {
          this.isLoading=true;
      let params = {
        Ref: ref,
        TurKodu: null,
        TurAdi: this.search,
        Notlar: null,
        Gece: 0,
        Gunduz: 0,
        Aktif: false,
        KategoriId: 0,
        UrunGrubuId: 0,
        Kontenjan: 0,
        KayitTarihi: "2020-01-01T00:00:00",
        tumSirketler: false,
        sayfaAdi: null,
      };
      tool.http_post(this, "MasterTurList", params).then(
        (response) => {
          if (response.body.Status == true) {
           
            this.items=response.body.data;
            const selectedItem = this.items[0]
            if (selectedItem && ref !== 0) {
              this.model = selectedItem.Id; // Seçili yap
            };
            this.isLoading=false;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
            this.isLoading=false;
          }
        },
        (response) => {
          this.text1 = "Hata Oluştu, tekrar deneyiniz";
          this.snackbar = true;
          this.loadingvmodel=false;
        }
      );
    },
    }
}
</script>